angular.module('storefrontApp')
    .filter('imgurl', () => function (input, type) {
        if (!type) {
            return input;
        }

        const extention = '.' + input.split('.').pop();
        const suffix = '_' + type;

        return input.replace(extention, suffix + extention);
    })

    .filter('productUrlWithVariation', () => function (variation) {
        if (variation.product && variation.product.titularItemId) {
            return '/product/' + variation.product.titularItemId + '?variation=' + variation.productId;
        }
        return '/product/' + variation.productId;
    })

    .filter('propertyByName', () => function (properties, propertyName) {
        const res = _.find(properties, (x) => x.name === propertyName);
        return res ? res.value : null;
    })

    .filter('propertyExist', () => function (properties, propertyName) {
        const res = _.find(properties, (x) => x.name === propertyName);
        return res && res.value;
    })

    .filter('encodeURIComponent', ['$window', function ($window) {
        return $window.encodeURIComponent;
    }])

    .filter('inches', () => function (input) {
        return input + '"';
    });
